import { atom } from "recoil";
export const zoomState = atom<string>({
  key: "zoomState",
  default: "1",
});
